import { Component, Injector } from '@angular/core';
import { BaseResourceListComponent, Coluna, Filtro, FormatoExportacao, LoginContabil, TransferenciaEspecie } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TransferenciaEspecieService } from '../service/transferencia-especie.service';

@Component({
  selector: 'lib-transferencia-especie-list',
  templateUrl: './transferencia-especie-list.component.html'
})
export class TransferenciaEspecieListComponent extends BaseResourceListComponent<TransferenciaEspecie, LoginContabil> {

  /**
   * Declaração de variáveis
   */


  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private modalidadeService: TransferenciaEspecieService) {
    super(modalidadeService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'orgao';
  }

  protected condicoesGrid(): {} {
    return {
      ['orgao.id']: this.login.orgao.id
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['id'];
  }

  protected filtrosGrid(): Filtro {
    return {
      number: ['id'],
      text: ['nome']
    };
  }

  protected afterInit(): void {
  }

  protected acaoRemover(model: TransferenciaEspecie): Observable<TransferenciaEspecie> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'ID', coluna: 'id' },
      { titulo: 'Nome', coluna: 'nome' }
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = 'orgao';
    this.modalidadeService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir(`LISTAGEM DE TIPOS DE TRANSFERÊNCIA`,
              this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao, 'portrait',
              'Listagem tipos de transferência', ['auto', '*'], lista.content);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public retornar() {
    this.router.navigate([`/cadastros-auxiliares`]);
  }
}
